import {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
} from 'react-phone-number-input/mobile';
import * as Yup from 'yup';
import { StringSchema as Original } from 'yup';
declare module 'yup' {
  interface StringSchema {
    phoneNumberStrict(): Original;
    phoneNumber(): Original;
  }
}

Yup.addMethod(Yup.string, 'phoneNumber', function () {
  return this.test({
    name: 'phoneNumber',
    exclusive: true,
    message: 'Ingresa un telefono valido',
    test: (value) => {
      try {
        return !value || value === '' || isPossiblePhoneNumber(value);
      } catch {
        return false;
      }
    },
  });
});

Yup.addMethod(Yup.string, 'phoneNumberStrict', function () {
  return this.test({
    name: 'phoneNumber',
    exclusive: true,
    message:
      'Ingresa un telefono celular válido. Por favor incluí el código de área (ejemplo: 011), y el 15. Ejemplo: 011 15 5976 0401',
    test: (value) => {
      try {
        return !value || value === '' || isValidPhoneNumber(value);
      } catch {
        return false;
      }
    },
  });
});
